export default __webpack_public_path__ + "static/media/Mission_img.72022625.jpg";